const BLOGS = [
    {
        slug: 'ai-a-mystery-nah-just-another-abstraction-over-programming',
        title: 'AI a mystery? Nah... just another abstraction over programming',
        excerpt: "After hearing a lot of AI jargons, I thought of sharing my perspective on AI and how it can be compared to components in a programming language.",
        date: 'Feb 24, 2026',
        readTime: '2 min read',
        accentColor: '#6750a4',
        tags: ['Artificial Intelligence', 'Programming'],
        content: [
            {
                type: 'paragraph',
                text: "Are you having a feeling that AI is a strange stuff and people having discussions using its \"jargons\" sound sudden aliens? Not anymore, because as a developer you already know the basics of how things work.",
            },
            {
                type: 'paragraph',
                text: 'IMO',
            },
            {
                type: 'quote',
                text: "The transition to AI can be seen as a transition from high level programming to contextual programming.",
            },
            {
                type: 'paragraph',
                text: "Ever since our school days, everyone must have mastered the art of learning new things i.e. comparing a new concept with a concept that we already know. In that way, things get simpler and easy to understand. AI is also not an exception. Let us compare AI with the programming concepts that we already know.",
            },
            {
                type: 'heading',
                text: 'LLM → Engine (JVM / NodeJS)',
            },
            {
                type: 'list',
                items: [
                    "The execution engine of intelligence.",
                    "No runtime environment → no program execution.",
                    "No LLM → no reasoning.",
                ],
            },
            {
                type: 'heading',
                text: "Model (e.g., Claude 3 Sonnet)",
            },
            {
                type: 'list',
                items: [
                    "eg: JDK 11 vs JDK 21, Node 25 vs Node 24",
                    "Same platform. Different capabilities, performance, and limits.",
                ],
            },
            {
                type: 'heading',
                text: "Prompt → Function call",
            },
            {
                type: 'code',
                language: 'java',
                text: 'ai.generate("Build JWT authentication");',
            },
            {
                type: 'paragraph',
                text: "You pass input and the engine returns output. ",
            },
            {
                type: 'heading',
                text: "Rules → Global configuration",
            },
            {
                type: 'list',
                items: [
                    "System-wide constraints that shape behavior",
                    "Rules do not execute business logic.",
                    "They influence how logic behaves.",
                    "eg: Annotations in Java or \"use strict\" in Javascript",
                ]
            },
            {
                type: 'heading',
                text: "Skills → Methods / Functions",
            },
            {
                type: 'list',
                items: [
                    "Reusable intelligence modules.",
                    "Encapsulated. Reusable. Callable.",
                ]
            },
            {
                type: 'code',
                language: 'java',
                text: `public class ApiSkill {            
    public void implementApi() {
        implementHandlers();
        addRestConfiguration();
        addSecurityConfiguration();
    }
}`,
            },
            {
                type: 'heading',
                text: "Agent → Stateful class with a control loop",
            },
            {
                type: 'list',
                items: [
                    "An agent is not a single method call.",
                    "It is orchestration + memory + iteration.",
                ]
            },
            {
                type: 'code',
                language: 'java',
                text: `public class SecretAgent {
    private boolean done = false;
    public void run() {
        while (!done) {
            plan();
            act();                                    
            observe();
        }
    }
}`,
            },
            {
                type: 'heading',
                text: "Context Window → Heap memory",
            },
            {
                type: 'paragraph',
                text: "How much data the system can hold and reason about at once.",
            },
            {
                type: 'heading',
                text: "Tokens → Compute cost (CPU + memory usage)",
            },
            {
                type: 'list',
                items: [
                    "Tokens are nothing but the semantic split of the prompt.",
                ]
            },
            {
                type: 'code',
                language: 'text',
                text: `Understanding tokens is important. -> Under | standing | tokens | is | important | .`,
            },
            {
                type: 'list',
                items: [
                    "In an algorithmic way, token usage can be compared with the complexity of a program.",
                    "More tokens = more processing = more cost.",
                    "As efficient users of AI, our goal is to minimize the use of tokens and getting things done synchronously.",
                ]
            },
            {
                type: 'heading',
                text: "MCP (Model Context Protocol) → APIs",
            },
            {
                type: 'list',
                items: [
                    "Helps the agent to perform actions more than just text prediction, like writing content to a file, fetching data etc.",
                    "Just like we use APIs for external operations.",
                ]
            },
            {
                type: 'paragraph',
                text: "In a nutshell,"
            },
            {
                type: 'list',
                items: [
                    "LLM → Engine",
                    "Model → Version",
                    "Rules → Configuration",
                    "Skills → Methods",
                    "Agent → Orchestrator",
                    "MCP → Tool interface layer",
                ]
            },
            {
                type: 'paragraph',
                text: "The millennials who were writing machine understandable low level code, at some point of time got adapted to high level languages. In the same way, this is just another adaptation to make work easier."
            }
        ],
    },
    {
        slug: 'mobile-app-development',
        title: 'Mobile App Development',
        excerpt: "A beginner's guide to mobile app development",
        date: 'Aug 17, 2021',
        readTime: '4 min read',
        accentColor: '#00bcd4',
        tags: ['Mobile App Development', 'Android', 'iOS', 'Flutter', 'React Native'],
        content: [
            {
                type: 'heading',
                text: "The App World"
            },
            {
                type: 'paragraph',
                text: "The present world has been brought inside your palm with a 6 inch device, the so called smart phones. Sarcastically saying, these devices have become an organ of the humans. This device has revolutionized the tech world since it was introduced, by performing tasks that had separate devices before, for example calculator, alarm clock etc. The reason behind the success of this device are the “Apps” that are present in the device, yes you read it write. Apps are the backbone of the features the user experiences through the mobile phone. Some apps like Whatsapp and YouTube have become mandatory for a mobile to have as almost all the smartphone in this planet has this app installed in them. From these we can conclude that a smartphone is nothing without apps, even though it may have fastest processor or world class hardware built into it. At present there are approximately 3.48 million apps in the Google Play Store and 2.2 million apps in the Apple App Store, so mobile app development is a field which has no end gate with accounting the next decade into consideration."
            },
            {
                type: 'heading',
                text: "What is app development?"
            },
            {
                type: 'paragraph',
                text: "So what is app development? The answer is simple, you design and develop apps for one or more operating systems, like Android, iOS etc. This may sound simple, but there are several processes that have to be undergone, from getting started with an IDE to deploying the app in the store for the use of people. An app may be a utility tool or a game also. There are several IDEs out there to develop the app you plan, for example Android Studio, Xcode, Unity, Unreal etc. You should be equipped with a personal computer or a mac machine to start working with these things."
            },
            {
                type: 'heading',
                text: "The development process"
            },
            {
                type: 'paragraph',
                text: "The development process is not that complex to be honest, you just start gathering the requirements, framing a plan with the gathered requirements, designing & programming the app and then you can deploy your app in the app stores for the use of others. The entire development can be categorized into two parts – front and back ends. Front end development includes the designing of user interface and basic functionality and back end development deals with the data base and server related works. If you want to develop apps quickly with a single code base you can go with cross platform app development tools like Flutter, React Native etc or if you really want to build apps that are completely native you can go with the native app development, unlike cross platform development it doubles the content you learn and also the development time but the final product will be quicker and highly efficient when compared to cross platform apps. Deciding the type of app development completely depends upon the needs."
            },
            {
                type: 'heading',
                text: "Monetizing your app"
            },
            {
                type: 'paragraph',
                text: "You can monetize your app in several ways, either you can include a paid feature in your app or include ads into your app using ad services like Google ads etc. But adding ads is not so pleasing for the end users. For an app to be successful it must be user friendly in its user interface & user experience, highly responsive and it should make the user feel as if he is using the app for the first time each and every time the user uses it, i.e. it must be refreshing and never boring. Most of the users may not like ads popping up, as it intervenes their flow."
            },
            {
                type: 'heading',
                text: "App development as a profession"
            },
            {
                type: 'paragraph',
                text: "Becoming an app developer can make you well recognizable among lot of people, as the demand for app developers keeps on rising. Many companies hire app developers with a considerably high salary package. Recent surveys say that the demand for app developers is high than that of web developers’. You can be more welcomed by companies if you have mastered both front and back ends. Free lancing is an another way you can earn money, free lancers are independent developers who develop apps for their clients in a individual planned basis. Free lancing can be a best option if you are not that interested in collaborative office work and you want to work completely on your own plans."
            },
            {
                type: 'heading',
                text: "Where to start?"
            },
            {
                type: 'paragraph',
                text: "If you want to pursue in becoming an app developer, there are many courses out there offered by both online and offline companies. Learning app development is not at all a herculean task, it all depends on your interest and all it includes is leaning a programming language and knowing how to work with an IDE. Making app based projects can enhance your app development skills especially if you are a student. Once you complete learning app development, you can either become an employee or a free lancer based on your interest and opinion. So it is a good thing to think in all possible ways before you choose anything."
            },
        ],
    },
];

export default BLOGS;
